import { CommentCommand } from 'logic/deviceScriptParser';

export type Props = {
    index: number;
    command: CommentCommand;
    onChangeComment(comment: string): void;
};

export const CommentCommandOptions = ({ index, command, onChangeComment }: Props) => {
    return (
        <span className="comment-command-options">
            <input
                type="text"
                id={ `update-comment-${index}` }
                value={ command.comment }
                onChange={ e => onChangeComment(e.target.value) }
                style={ { width: '70%' } }
            />
        </span>
    );
};
